

import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

import LMModule from "@/components/locker/modules/LMModule.vue";
import {IErrors} from "@/model/IErrors";
import {IAbstractCell, ICell, ILocker} from "@/model/Locker/lockerInterfaces";
import {CellStructureBuilder} from "@/helpers/CellStructureBuilder";
import ServiceProviderSearch from "@/components/serviceProvider/widget/ServiceProviderSearch.vue";

@Component({
    name: 'LMCreateModuleDialog',
    components: {
      LMModule,
      ServiceProviderSearch,
    }
  })
  export default class LMCreateModuleDialog extends Vue {

    @Prop()
    protected lockerId!: number;

    get types() {
      // segment into groups (screen and columns)
      return CellStructureBuilder.moduleDefsUIOrdered;
    }
    get module() {

      const selectedType = parseInt(this.moduleType);
      if (isNaN(selectedType)) {
        return {};
      }
      const moduleDef = CellStructureBuilder.moduleDefsUIOrdered[selectedType];

      return Object.assign(
          {
            block: this.nextAvailableBlock,
          },
          moduleDef ? moduleDef : {});
    }

    protected showing: boolean = false;
    protected disabled: boolean = false;
    protected subscribes: object = {};
    protected errors: string[] = [];
    protected moduleType: string = '';
    protected nextAvailableBlock: number = 0;
    protected showRestrictions: boolean = false;
    private selectedServiceProviderId: number|null = null;

    created() {
      this.subscribes = this.$ons({
        'l-m-create-module-dialog.show': this.onShow,
        'backend.call.begin.lockerLoaded': this.onDisable,
        'backend.call.OK.lockerLoaded': this.onHide,
        // @todo?
        'backend.call.KO.lockerLoaded': this.onError,
      });
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected onShow(locker: ILocker) {
      this.nextAvailableBlock = 0;
      locker.cells.forEach((eachCell: ICell) => {
        this.nextAvailableBlock = Math.max(eachCell.block+1, this.nextAvailableBlock);
      });
      this.moduleType = '';
      this.errors = [];
      this.disabled = false;
      this.showing = true;
    }
    protected onHide() {
      this.showing = false;
    }
    protected onSubmit() {
      let cells: any[] = [];
      // @ts-ignore
      this.module.columns.forEach((eachColumn: any[]) => {
        eachColumn.forEach((eachCell: IAbstractCell) => cells.push(eachCell))
      });
      const payload: any = {
        lockerId: this.lockerId,
        block: this.nextAvailableBlock,
        direction: 'right',
        cells: cells,
      };
      if (this.selectedServiceProviderId) {
        payload.onlyForSp = this.selectedServiceProviderId;
      }
      this.$store.dispatch('lockerModule/createModule', payload);
    }
    protected onDisable() {
      this.disabled = true;
    }
    protected onError(errors: IErrors) {
      this.disabled = false;
      this.errors = errors._ || ['?????'];
    }

    protected onServiceProviderSelected(serviceProviderId: number|null) {
      this.selectedServiceProviderId = serviceProviderId;
    }

  }

